export const iconFontAwesomeMapsLifeRing = (
	<i className="fa-solid fa-life-ring"></i>
);
